import $ from 'jquery'
import * as infiniteScroll from './infinite-scroll.js'

const newsSet = {
  dataKeeper: '#news-overview-data-keeper-js',
  overviewContainer: '#news-overview-container',
  overviewInfiniteScrollingMarker: '#news-overview-infinite-scrolling-marker',
  btn: '.js-open-article',
  selector: '.two-column-wrapper',
  renderIdentify: 'news-overview-render-url'
}

const catYearMap = window.newsCatYearMap
const groupCatYearMap = window.groupCatYearMap

function init () {
  if ($(newsSet.dataKeeper).length !== 0) {
    const $yearDropDown = $('#news-overview-page #year-dropdown')
    let $catDropDown = window.includeGroupNews ? $('#news-overview-page #nationalInternationalDropdown') : $('#news-overview-page #category-dropdown')
    let filterMapping = window.includeGroupNews ? groupCatYearMap : catYearMap

    syncFiltersWithMap(filterMapping, $catDropDown, $yearDropDown)

    $catDropDown.on('change', function (el) {
      const years = getYearsForCat(filterMapping, $(el.target).val())
      $yearDropDown.children('option').each((i, v) => {
        const $v = $(v)
        const optionVal = $v.val()
        const isBeforeOption = optionVal.indexOf('before') === 0
        if (optionVal) {
          if (isBeforeOption) {
            const year = /^before_(\d+)/.exec(optionVal)[1]
            if (!years.some(value => value < parseInt(year))) {
              hideDropDownOption($yearDropDown, optionVal)
            } else {
              showDropDownOption($yearDropDown, optionVal)
            }
          } else {
            if (years.indexOf(parseInt(optionVal)) === -1) {
              hideDropDownOption($yearDropDown, optionVal)
            } else {
              showDropDownOption($yearDropDown, optionVal)
            }
          }
        }
      })
      startFilter()
    })

    $yearDropDown.on('change', function (el) {
      const newVal = $(el.target).val()
      const cats = getCatsForYear(filterMapping, newVal)
      $catDropDown.children('option').each((i, v) => {
        const $v = $(v)
        const optionVal = $v.val()
        if (optionVal) {
          if (cats.indexOf(optionVal) === -1) {
            hideDropDownOption($catDropDown, optionVal)
          } else {
            showDropDownOption($catDropDown, optionVal)
          }
        }
      })
      if (!newVal.endsWith('_external')) {
        startFilter()
      }
    })

    $('#news-overview-page .filter-reset-js').on('click', function () {
      syncFiltersWithMap(filterMapping, $catDropDown, $yearDropDown)
      infiniteScroll.resetFilterObject()
      infiniteScroll.resetPage()
      infiniteScroll.emptyContent()
      setTimeout(function () {
        infiniteScroll.getArticles()
      }, 500)
    })

    $('#news-overview-page #filter-search-input').on('keypress', function (e) {
      if (e.keyCode == 13) {
        startFilter()
      }
    })

    $('#news-overview-page #filter-search-input').siblings('.search-icon').on('click', function () {
      startFilter()
    })

    setTimeout(function () {
      const initialFilter = decodeURIComponent(window.location.href).split('website:category,')[1]
      if (initialFilter != undefined && $('#category-dropdown').length) {
        $('#category-dropdown').val(initialFilter).prop('selected', true)
        if ($('#category-dropdown').val() != null) {
          $('#category-dropdown').trigger('update')
        }
      }
    }, 250)

    infiniteScroll.init(newsSet)

    // for filters
    infiniteScroll.setFilterElements($catDropDown, $yearDropDown, $('#news-overview-page #filter-search-input'))
  }

  function startFilter () {
    infiniteScroll.setFilter()
    infiniteScroll.resetPage()
    infiniteScroll.emptyContent()
    setTimeout(function () {
      infiniteScroll.getArticles()
    }, 500)
  }

  // for filters
}

/**
 * hides or show filter options depending on whether any news are availble for them
 * @param catYearMap
 */
function syncFiltersWithMap (catYearMap = [], $catDropDown, $yearDropDown) {
  $catDropDown.children('option').each((i, _v) => {
    const v = $(_v)
    if (v.val()) {
      if (!hasCat(catYearMap, v.val())) {
        hideDropDownOption($catDropDown, v.val())
      } else {
        showDropDownOption($catDropDown, v.val())
      }
    }
  })
  $yearDropDown.children('option').each((i, _v) => {
    const v = $(_v)
    if (v.val()) {
      const isBeforeOption = v.val().indexOf('before') === 0
      if (!isBeforeOption && !hasYear(catYearMap, v.val())) {
        hideDropDownOption($yearDropDown, v.val())
      } else if (isBeforeOption) {
        // special handling for before option
        const year = /^before_(\d+)/.exec(v.val())[1]
        if (!catYearMap.some(value => value.year < parseInt(year))) {
          hideDropDownOption($yearDropDown, v.val())
        } else {
          showDropDownOption($yearDropDown, v.val())
        }
      } else {
        showDropDownOption($yearDropDown, v.val())
      }
    }
  })
}

/**
 * Removes a dropdown item from our homebrew dropdown.
 * It has a select and a div per option.
 * @param $dropdown
 * @param optionVal
 */
function hideDropDownOption ($dropdown, optionVal) {
  if ($dropdown && !optionVal.endsWith('_external')) {
    $dropdown.find(`option[value=${optionVal}]`).not(`option[value=all]`).hide()
    $dropdown.parent().find(`[data-dropdown-value=${optionVal}]`).not(`[data-dropdown-value=all]`).hide()
  }
}

function showDropDownOption ($dropdown, optionVal) {
  if ($dropdown) {
    $dropdown.find(`option[value=${optionVal}]`).show()
    $dropdown.find(`option[value=all]`).show()
    $dropdown.parent().find(`[data-dropdown-value=${optionVal}]`).show()
    $dropdown.parent().find(`[data-dropdown-value=all]`).show()
  }
}

function hasYear (catYearMap = [], year) {
  return catYearMap.some(v => v.year === parseInt(year))
}

function hasCat (catYearMap = [], cat) {
  return catYearMap.some(v => v.cat === cat)
}

function getYearsForCat (catYearMap = [], cat) {
  if (cat === 'all') {
    return catYearMap.map(v => v.year)
  } else {
    return catYearMap.filter(v => v.cat === cat)
      .map(v => v.year)
  }
}

function getCatsForYear (catYearMap = [], year) {
  const isBeforeOption = year.indexOf('before') === 0
  return catYearMap.filter(v => {
    if (isBeforeOption) {
      const intYear = parseInt(/^before_(\d+)/.exec(year)[1])
      return v.year < parseInt(intYear)
    } else if (year.indexOf('all') === 0) {
      return v
    }
    return v.year === parseInt(year)
  })
    .map(v => v.cat)
}

export default {
  init
}
